 
import { createProjectGroup, updateProjectGroup } from '@/api/enterprise'

export default {
  components: {
  },
  props: ['info'],
  data() {    
    return {
        form: {
            group_id: '',
            group_name: ''
        },
        layerLoading: false,
    }
  },
  mounted() { 
    if (this.info) {
      this.form = this.info
    }
        
  },
  methods: {
    save() {
        this.$refs['form'].validate( async (valid) => {
          if (valid) {
            this.layerLoading = true            
            if (this.form.group_id) {
              await updateProjectGroup({group_name: this.form.group_name, group_id: this.form.group_id})
            } else {
              await createProjectGroup(this.form)
            }
            
            this.layerLoading = false
            this.$layer.closeAll()
            this.$parent.fetch()
          } else {
            return false;
          }
        });
        
    }
  }
}
